import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Heading, SectionLabel } from './ui-bits';

export default function CTABanner() {
  return (
    <section className="relative bg-[#053e49] text-[#faf4ea] py-28 md:py-36 overflow-hidden">
      <div className="absolute inset-0 opacity-20" style={{backgroundImage:'url(https://images.unsplash.com/photo-1727425383452-2be55354f06e)', backgroundSize:'cover', backgroundPosition:'center'}} />
      <div className="absolute inset-0 bg-gradient-to-b from-[#053e49] via-[#053e49]/85 to-[#053e49]" />
      <div className="relative max-w-[1200px] mx-auto px-6 md:px-10 text-center">
        <SectionLabel align="center" dark>Let's begin</SectionLabel>
        <Heading dark className="mt-5 font-serif italic">Let’s find your somewhere.</Heading>
        <p className="mt-7 text-[#d8d0bf] max-w-2xl mx-auto text-lg leading-relaxed">
          Every destination wedding begins with a conversation. Tell us what you’re imagining—even if all you know today is: “We want to get married somewhere beautiful.” We’ll start from there.
        </p>
        <div className="mt-10 flex items-center justify-center gap-4 flex-wrap">
          <Link to="/plan" className="btn-gold">Plan My Wedding <ArrowRight size={16} /></Link>
          <Link to="/destinations" className="btn-ghost">Explore Destinations</Link>
        </div>
      </div>
    </section>
  );
}
